// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0074D9","textColor":"#111","backgroundColor":"#fff"};